export default __webpack_public_path__ + "static/media/store.11a612d3.png";